export type ACTION_RUNNING_TYPE =
  | 'messages'
  | 'salesNavMessages'
  | 'connections'
  | 'sentInvitations';

export type ContextStateProps = {
  port: chrome.runtime.Port | undefined;
  extensionId: string | undefined;
  extensionUpdatedVersionAvailable: string | undefined;
  extensionConnectedStatus: 'loading' | 'connected' | undefined;
  isRunning: boolean;
  observer: MutationObserver | undefined;
  reconnectAttempts: number;
  running: ACTION_RUNNING_TYPE[];
  runningCadenceId?: string;
  runningStepId?: string;
}

export const initialValue: ContextStateProps = {
  port: undefined,
  extensionId: undefined,
  extensionConnectedStatus: undefined,
  extensionUpdatedVersionAvailable: undefined,
  isRunning: false,
  observer: undefined,
  reconnectAttempts: 0,
  running: [],
  runningCadenceId: undefined,
  runningStepId: undefined,
};

export type Actions =
  | { type: 'SET_OBSERVER'; observer: MutationObserver | undefined }
  | { type: 'SET_EXTENSION_ID'; id: string | undefined }
  | { type: 'SET_EXTENSION_UPDATED_VERSION_AVAILABLE'; version: string | undefined }
  | { type: 'CONNECT'; port: chrome.runtime.Port | undefined }
  | { type: 'CONNECT_AWK' }
  | { type: 'RUNNING'; action: ACTION_RUNNING_TYPE }
  | { type: 'RUN_CADENCE_FINISHED' }
  | { type: 'RUN_STEP_FINISHED' }
  | { type: 'RUN_STEP_START'; id: string }
  | { type: 'RUN_CADENCE_START'; id: string; explicitCadenceIds: string[] | undefined }
  | { type: 'DISCONNECT' };

export const reducer = (state: ContextStateProps, action: Actions): ContextStateProps => {
  switch (action.type) {
    case 'RUN_CADENCE_START': {
      return { ...state, isRunning: true, running: [], runningCadenceId: action.id };
    }
    case 'RUN_STEP_START': {
      return { ...state, isRunning: true, running: [], runningStepId: action.id };
    }
    case 'SET_OBSERVER': {
      return { ...state, observer: action.observer };
    }
    case 'CONNECT': {
      return { ...state, port: action.port, extensionConnectedStatus: 'loading' };
    }
    case 'SET_EXTENSION_ID': {
      return { ...state, extensionId: action.id };
    }
    case 'SET_EXTENSION_UPDATED_VERSION_AVAILABLE': {
      return { ...state, extensionUpdatedVersionAvailable: action.version };
    }
    case 'CONNECT_AWK': {
      return { ...state, reconnectAttempts: 0, extensionConnectedStatus: 'connected' };
    }
    case 'RUNNING': {
      return {
        ...state,
        isRunning: true,
        running: state.running.includes(action.action)
          ? state.running
          : [...state.running, action.action],
      };
    }
    case 'RUN_STEP_FINISHED': {
      return { ...state, isRunning: false, running: [], runningStepId: undefined };
    }
    case 'RUN_CADENCE_FINISHED': {
      return { ...state, isRunning: false, running: [], runningCadenceId: undefined };
    }
    case 'DISCONNECT': {
      return {
        ...state,
        port: undefined,
        reconnectAttempts: state.reconnectAttempts + 1,
        extensionConnectedStatus: undefined,
        extensionId: state.reconnectAttempts >= 2 ? undefined : state.extensionId,
      };
    }
    default: {
      return state;
    }
  }
};
